import React, {Children, Suspense, useCallback, useEffect, useState} from "react";
// @ts-ignore
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
// @ts-ignore
import {Container} from "reactstrap";
import {
  AppAside,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";
import DefaultAside from "./DefaultAside";
import DefaultHeader from "./DefaultHeader";
import stateList from "./DefaultStates";
import {authenticationService} from "../../services/authentication";
import {useDispatch, useSelector} from "react-redux";
import AlertMessage from "../../views/AlertMessage/AlertMessage";
import {alertConstants} from "../../constants";
import {Slide, toast, ToastContainer, ToastOptions} from 'react-toastify';
// @ts-ignore
import version from "../../version.json"

import "react-toastify/dist/ReactToastify.css";
import * as apiCalls from '../../ApiCalls';
import "./DefaultLayout.scss";
import {clearUser, setUser} from "../../redux/user.reducer";
import {clearPermissions, setPermissions} from "../../redux/permissions.reducer";
import {setSettings} from "../../redux/settings.reducer";
import {HandleAPIErrorContext, ToastContext} from "../context";
import {RootState, useAppSelector} from "../../redux/store";
import axios, {AxiosError} from "axios";

function Layout(props:any) {
  const location = useLocation<{ alertMsgs?: AlertMessageType[], from: any }>();
  const history = useHistory();

  const portalPermissions = useAppSelector((state) => state.permissions.permissions);
  const portalSettings: any = useSelector((state: RootState) => state.settings.settings);
  const portalUser: any = useSelector((state: RootState) => state.authentication.user);
  const dispatch = useDispatch();

  const [nav, setNav] = useState(navigation);
  const [redirect, setRedirect] = useState<string>(sessionStorage.getItem('redirect') ?? '/');
  const [componentStates, setComponentStates] = useState(stateList);
  const [alerts, setAlerts] = useState(location.state?.alertMsgs ?? []);
  const [loading, setLoading] = useState(true);

  const handleApiError = useCallback((error?: AxiosError | string | { errMsg?: string, response?: { data?: any } } | Error ) => {
    if (!error) return;

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message?: string | { error: string } }>
      if (typeof axiosError.response?.data.message === 'string') {
        addAlert({ msg: axiosError.response?.data.message ?? axiosError.message, type: alertConstants.ERROR });
      } else {
        addAlert({ msg: axiosError.response?.data.message?.error ?? axiosError.message, type: alertConstants.ERROR });
      }
    } else if (typeof(error) === 'string') {
      addAlert({ msg: error, type: alertConstants.ERROR });
    } else if (error instanceof Error) {
      addAlert({ msg: error.message, type: alertConstants.ERROR });
    } else if (error.errMsg) {
      addAlert({ msg: error.errMsg, type: alertConstants.ERROR });
    } else if (error.response?.data) {
      addAlert({ msg: error.response.data, type: alertConstants.ERROR });
    }
  }, []);

  const fetchNluVersion = useCallback(() => {
    if (Object.keys(portalPermissions).length === 0)
      return

    apiCalls.getActiveNluVersion()
      .then((response) => {
        if (response.fileName) {
          sessionStorage.setItem('NluVersion', JSON.stringify(response));
        }
      })
      .catch((err) => handleApiError(err));
  }, [handleApiError, portalPermissions]);

  const setServiceEnabled = useCallback((service: any) => {
    let serviceAttributes = {};

    //DELETE?
    // if (['Identity Provider', 'User Profiles', 'Callback Service'].includes(service.name)) {
    //   serviceAttributes = { disabled: true };
    // } else if (['Dialog Editor', 'Survey Service'].includes(service.name)) {
    //   serviceAttributes = { hidden: true };
    // }

    if(service.children){
      service.children.forEach((child:any)=>{
        setServiceEnabled(child)
      })
    }
    
    if(Object.keys(portalPermissions).includes(service.url)){
      service.attributes = {disabled: false}
      service.class = ""
    }
    else
    {
      service.attributes = { disabled: true };
      service.class = 'disabled-item'
      service?.children?.forEach((child:any)=>{
        child.class = 'sidebar-child-nav-item disabled-item'
        child.attributes = { disabled: true };
        return child
      })
    }
  }, [portalSettings.services, portalPermissions]);

  const updateNavigationTabs = useCallback((route: string) => {
    setNav((prevState) => {
      const items = prevState.items.map((page) => {
        if (page.subDir?.includes(route)) {
          return { ...page, url: route }
        } else {
          return { ...page };
        }
      })

      return { items }
    })
  }, []);

  useEffect(() => {
    if (Object.keys(portalPermissions).length === 0 || !portalSettings?.mode)
      return;

    const modeRoutes = routes[portalSettings.mode];
    const availableRoutes = Object.keys(portalPermissions)
      .filter((permission) => modeRoutes.some((route) => route.path === permission));

    const items = navigation.items.filter((item) => {
      if (item.children) {
        return item.children.filter((child) => availableRoutes.includes(child.url)).length > 0;
      } else {
        return availableRoutes.includes(item.url)
      }
    }).map((item) => {
      if (item.children) {
        const children = item.children.filter((child) => availableRoutes.includes(child.url));
        return {...item, children};
      } else {
        return {...item};
      }
    })

    //disabled parent conversations based on enabled/disabled components
    items[0].name = portalSettings.projectName;

    
    items.forEach((val)=> {
     
      let enabled = val.children?.map(v=>v.url).filter(x=>availableRoutes.indexOf(x) !== -1) || []
      if(val?.children && val?.children?.length > 0 && enabled.length == 0 ){
        val.class =( val?.class || '') + ' disabled-item'
      }
    })

    if(items[0].children){
      items[0]?.children.forEach((val)=> {
        if(val.children){
          let enabled = val.children?.map(v=>v.url).filter(x=>availableRoutes.indexOf(x) !== -1) || []
          if(val?.children && val?.children?.length > 0 && enabled.length == 0 ){
            val.class =( val?.class || '') + ' disabled-item'
          }
        }
      })
    }

    setNav({ items });
    setLoading(false);
  }, [portalPermissions, portalSettings.mode, portalSettings.projectName]);

  const updatePermissions = useCallback(() => {
    Promise.all([apiCalls.getUserProfile(), apiCalls.fetchSettings(), apiCalls.fetchPermissions(), apiCalls.userExpired()])
      .then(([profile, settings, permissions, userExpired]) => {
        if (profile.user.forceReset) {
          sessionStorage.setItem('redirect', location.pathname + location.search);
          authenticationService.logout();
        } else {
          dispatch(setUser(profile.user));
          dispatch(setSettings(settings.settings));
          dispatch(setPermissions(permissions.permissions));
          authenticationService.startTimeout(permissions.expiration * 1000);
          if (!userExpired.sessionValid) {
            window.location.href = "/#/login";
          }
          else if (settings.settings.mode === 'cbsaOnly') {
            setRedirect('/callback-service');
          }
          else if (settings.settings.mode === 'syf') {
            setRedirect('/trends');
          }
          else if (redirect !== '/') {
            // Nothing goes here
          }
          else {
            setRedirect('/live');
          }

          sessionStorage.removeItem('redirect');
        }
      })
      .catch((err) => {
        console.error(err);
        sessionStorage.setItem('redirect', location.pathname + location.search);
        authenticationService.logout();
      })
  }, [dispatch, location, redirect]);

  useEffect(() => {
    nav.items.forEach((item) => item.children?.forEach(setServiceEnabled));
  }, [nav, setServiceEnabled]);

  useEffect(() => {
    return () => {
      dispatch(clearUser());
      dispatch(clearPermissions());
    }
  }, [dispatch]);

  useEffect(() => {
    updatePermissions();
  }, [updatePermissions]);

  useEffect(() => {
    fetchNluVersion();
  }, [fetchNluVersion]);

  useEffect(() => {
    setAlerts(location.state?.alertMsgs ?? []);
  }, [location]);

  useEffect(() => {
    if (location.state?.from && history.location.pathname !== location.state.from)
      history.push({ pathname: location.state.from });
  }, [history, location.state?.from, portalPermissions]);

  function displayToast(message: string, type: ToastOptions['type'] = 'success') {
    toast(message, { type });
  }

  function handleSaveState(url: string, state: any) {
    setComponentStates((states) => (
      states.map((s) => {
        if (s.path === url)
          s.stateInit = state;
        return s;
      })
    ))
  }

  function addAlert(alertMessage: AlertMessageType) {
    setAlerts((messages) => messages.concat(alertMessage));
  }

  function formatCount(count: any) {
    if (count && !isNaN(count))
      return count.toLocaleString();
    return count;
  }

  if (loading) {
    return null;
  }

  // @ts-ignore
  return (
    <div className={'app'}>
      <AppHeader fixed className={'app-header'}>
        <DefaultHeader />
      </AppHeader>
      <div className={'app-body'}>
        <ToastContainer position={'top-center'} autoClose={3000} hideProgressBar newestOnTop
                        closeOnClick rtl={false} pauseOnFocusLoss draggable={false}
                        pauseOnHover={false} limit={2} transition={Slide} />

        <AppSidebar fixed display={'lg'} className={'app-sidebar'}>
          <AppSidebarHeader />
          <AppSidebarForm />
          <AppSidebarNav className={'app-sidebar-nav-white'} navConfig={nav} location={location} />
          <AppSidebarFooter className={'app-sidebar-footer'}>
            <h6 className={'version-number'}>{version.version}</h6>
          </AppSidebarFooter>
        </AppSidebar>

        <main className={'main main-container'}>
          <div className={'mez-banner full-width'}>
            {portalSettings.projectName}
          </div>
          <Container className={'content-container'} fluid>
            {alerts.map((a, index) => <AlertMessage key={index} {...a} />)}
            <Switch>
              {/* @ts-ignore */}
              {portalSettings.mode && routes[portalSettings.mode]?.map((route: any, index) => {
                const state = componentStates.find((c) => c.path === route.path) ?? { stateInit: null };
                const component = nav.items.find((item) => {
                  if (item.children)
                    return item.children.find((child) => route.path.startsWith(child.url));
                  return route.path.startsWith(item.url);
                });

                // @ts-ignore
                const disabled = component && (component.attributes?.hidden || component.attributes?.disabled);
                if (!route.component || disabled || Object.keys(portalPermissions).length === 0)
                  return null;

                return (
                  <Route key={index} path={route.path} exact={route.exact} render={(routeProps) => {
                    if (Object.keys(portalPermissions ?? {}).includes(route.path)) {
                      return (
                        <HandleAPIErrorContext.Provider value={handleApiError}>
                          <ToastContext.Provider value={displayToast}>
                            <Suspense fallback={<div>Loading...</div>}>
                              <route.component {...routeProps} saveState={handleSaveState} state={state.stateInit}
                                               updateNav={updateNavigationTabs} addAlertMsg={addAlert}
                                               handleAPIError={handleApiError}
                                               displayToast={displayToast} updateAppPermissions={updatePermissions}
                                               formatCount={formatCount} user={portalUser} settings={portalSettings}
                                               permissions={portalPermissions}/>
                            </Suspense>
                          </ToastContext.Provider>
                        </HandleAPIErrorContext.Provider>
                      );
                    }
                    else {
                      return (
                        <Redirect to={{
                          pathname: redirect,
                          state: {
                            alertMsgs: [{
                              msg: 'User is not authorized to access the requested page',
                              type: alertConstants.ERROR
                            }]
                          }
                        }} from={route.path} />
                      )
                    }
                  }} />
                )
              })}
              <Redirect from={'/'} to={location.pathname === '/' ? redirect : location.pathname + location.search} />
            </Switch>
          </Container>
        </main>

        <AppAside fixed>
          <DefaultAside />
        </AppAside>
      </div>
    </div>
  )
}

export default Layout;
